import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';


const setFndFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};
const clearFndFormData = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_FND_FORM_DATA]: setFndFormData,
  [TYPES.CLEAR_FND_FORM_DATA]:clearFndFormData
});
